import { gql } from '@apollo/client';
const REMOVE_WAREHOUSE_RELEASE = gql `
  mutation RemoveWarehouseRelease($warehouseReleaseNodeId: ID!) {
    removeWarehouseReleaseDraft(warehouseReleaseNodeId: $warehouseReleaseNodeId) {
      removed
    }
  }
`;
export default REMOVE_WAREHOUSE_RELEASE;
